import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { teamRoleSelector } from './selectors/team';
import type { StoredTeamRole } from './types';
import { objValueNullToUndefined } from '../lib/utils';
import { genericScalars } from '../lib/graphql/helpers';

const teamRoleQueryName = 'queryTeamRoleForImtData';

const useQueryTeamRoleForImtData = (
  search: string,
  onCompleted?: (d: readonly StoredTeamRole[]) => void,
  onError?: (e: ApolloError) => void
) => {
  const result = useTypedQuery(
    {
      team_role: [
        {
          where: {
            _or: [
              {
                name: { _ilike: `%${search}%` },
              },
              {
                abbreviation: { _ilike: `%${search}%` },
              },
            ],
          },
        },
        teamRoleSelector,
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: {
        onCompleted: (data) => {
          if (onCompleted !== undefined) {
            const queriedTeamRoles: readonly StoredTeamRole[] = data.team_role
              .map((team_role) =>
                objValueNullToUndefined<StoredTeamRole>(team_role)
              )
              .filter(
                (team_role): team_role is StoredTeamRole =>
                  team_role !== undefined
              );

            onCompleted(queriedTeamRoles);
          }
        },
        onError,
      },
      operationOptions: {
        operationName: teamRoleQueryName,
      },
    }
  );

  return result;
};

export default useQueryTeamRoleForImtData;
